import React, { Component } from 'react'
import {
    setAdminPage,
    roomSelectorStatus,
    getRoomList,
    setLoadingMass,
    setConformationPage
} from '../../../action/action'
import { connect } from 'react-redux'
// import { deviceRegColorset } from '../../JS/setColors'
import { setWebViewAfterKeyBoard } from '../../../JS/setWebView'
import { wipeGuestData } from '../../../JS/wipeGuestData';
import { INROOMTAB } from '../../../config/constant';

class RoomSelection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentRoom: "",
            error: false,
            errorMsg: null
        }
    }
    componentDidMount() {
        console.log("connectorIP", this.props.ConnectorIP);
        // deviceRegColorset(this.props.menuColor);
        this.props.getRoomList(this.props.ConnectorIP);
        this.props.setLoadingMass(false);
    }

    onNoClick = () => {
        this.props.setConformationPage(true);
        //this.props.setAdminPage(false);
        //this.props.roomSelectorStatus(false);
    }
    selectedRoom = (event, room) => {
        wipeGuestData(INROOMTAB);
        event.preventDefault();
        let status = false;
        let obj;
        this.props.locations.map((iterator) => {
            if (iterator.locationNumber == room) {
                status = true;
                obj = iterator;
            }
        })
        if (status && room && room.length > 0) {
            // localStorage.setItem("room", room);
            localStorage.setItem("roomID", obj.id);
        }
        localStorage.setItem("ConnectorIP", this.props.ConnectorIP);
        console.log("room.locationNumber", room);
        localStorage.setItem("GuestJourneySessionToken", "");
        document.location.reload();
    }
    setCurrentRoom = (room) => {
        this.setState({ currentRoom: room.locationNumber });
    }
    handleCHange = (event) => {
        event.preventDefault();
        let len = event.target.value.length;
        let str = event.target.value.charAt(len - 1);
        let dReg = new RegExp('^[a-zA-Z0-9 ]+$');
        if (str.match(dReg) || str === "-" || str === "_" || len === 0) {
            console.log("dReg is true.");
            this.setState({ currentRoom: event.target.value, error: false });
        } else {
            this.setState({
                currentRoom: event.target.value.substring(0, len - 1),
                error: true, errorMsg: `${str} is invalid input character.`
            });
        }
        this.setState({ currentRoom: event.target.value });
    }

    submitKeyEvent = (event) => {
        if (event.keyCode === 13) {
            console.log("keycode", event.keyCode);
            //let currentFocusedEle = document.getElementById("ipAddressField");
            //var type = currentFocusedEle.hasAttribute('type');
            document.getElementById("roomRegNext").click();
            event.preventDefault();
        }
    }

    render() {
        return (
            <div id="roomSelect" class="form">
                <form className="form" style={{ color: "black" }}>
                    <div className="form-item" style={{ color: "inherit" }}>
                        <label for="client-name" style={{ color: "inherit" }}>{this.props.stringConst.roomSelect}</label>
                        <input type="text" value={this.state.currentRoom}
                            style={{ color: "inherit", width: "100%" }} onChange={this.handleCHange}
                            name="deviceName" onKeyDown={this.submitKeyEvent}
                            minlength="2" maxlength="50"
                            onBlur={(event) => { setWebViewAfterKeyBoard(event) }} />
                    </div>
                    <div style={{ padding: "1rem", color: "red" }}>
                        {
                            this.state.error ?
                                this.state.errorMsg : null
                        }
                    </div>
                    <div className="form-item" style={{ color: "inherit" }}>
                        <div className="scroll vertical" style={{ color: "inherit" }}>
                            <div className="scroll-nav"><i className="fa fa-chevron-up" style={{ color: "inherit" }}></i></div>
                            <div className="scroll-thumbs" style={{ height: "10rem", color: "inherit", overflow: "scroll" }}>
                                <ul style={{ color: "inherit" }}>
                                    {
                                        this.props.locations.length > 0 ?
                                            this.props.locations.map((iterator, index) => {
                                                if (iterator.locationNumber.indexOf(this.state.currentRoom) !== -1) {
                                                    return (
                                                        < li style={{ color: "inherit" }} onClick={() => { this.setCurrentRoom(iterator) }}>
                                                            {iterator.locationNumber}
                                                        </li>
                                                    )
                                                }
                                            })
                                            : null
                                    }
                                </ul>
                            </div>
                            <div className="scroll-nav"><i className="fa fa-chevron-down" style={{ color: "inherit" }}></i></div>
                        </div>
                    </div>
                    <div className="form-controls">
                        <button id="roomRegNext" className="primary"
                            onClick={(event) => { this.selectedRoom(event, this.state.currentRoom) }}>{this.props.stringConst.proceed}</button>
                        <button className="secondary" onClick={() => { this.onNoClick() }}>{this.props.stringConst.cancel}</button>
                    </div>
                </form >
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        locations: state.store.deviceReg.locations,
        ConnectorIP: state.store.deviceReg.connectorIP,
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor
    }
}
export default connect(
    mapStateToProps,
    {
        setAdminPage,
        roomSelectorStatus,
        getRoomList,
        setLoadingMass,
        setConformationPage
    }
)(RoomSelection);